export default {"src":"/_next/static/media/symbol-icon-line.07aaa951.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};